import React from "react";
import PropTypes from "prop-types";
import { TableCell } from "@mui/material";
import { withStyles } from "@mui/styles";

const styles = (theme) => ({
  clickable: {
    cursor: "pointer",
    color: theme.palette.primary.light,
    fontWeight: "bold",
  },
});

const ClickableTableCell = ({ classes, children, ...rest }) => (
  <TableCell className={classes.clickable} {...rest}>
    {children}
  </TableCell>
);

ClickableTableCell.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default withStyles(styles)(ClickableTableCell);
